export function ColumnChartIcon() {
  return (
    // eslint-disable-next-line github/a11y-svg-has-accessible-name
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="15.25" y1="14.25" x2="0.75" y2="14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <rect
        x="2.75"
        y="6.75"
        width="1.5"
        height="7.5"
        rx="0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect
        x="6.75"
        y="4.75"
        width="1.5"
        height="9.5"
        rx="0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect
        x="10.75"
        y="9.75"
        width="1.5"
        height="4.5"
        rx="0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}

try{ ColumnChartIcon.displayName ||= 'ColumnChartIcon' } catch {}